import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import {
  usePurchasedGoodsFoodInsightsRetrieve,
  usePurchasedGoodsPackagingInsightsRetrieve,
} from '@shared/api/lib/purchased-goods/purchased-goods';
import {
  PurchasedGoodItemInsights,
  PurchasedGoodsFoodInsightsRetrieveParams,
  PurchasedGoodsPackagingInsightsRetrieveParams,
} from '@shared/api/types';

/**
 * Per-item insights for a food and drink purchased good: headline totals,
 * previous-year equivalents, the monthly emissions/spend series, suppliers
 * and available filter options. Computed live from purchase records.
 */
export const useGetPurchasedFoodAndDrinkItemInsights = (
  activityUuid: string,
  params?: PurchasedGoodsFoodInsightsRetrieveParams
) =>
  usePurchasedGoodsFoodInsightsRetrieve<PurchasedGoodItemInsights>(
    activityUuid,
    params,
    {
      request: useAxiosConfig(),
      query: {
        keepPreviousData: true,
        enabled: !!activityUuid,
      },
    }
  );

/**
 * Per-item insights for a packaging purchased good. Same shape as the food
 * variant; weight is the packaging material weight.
 */
export const useGetPurchasedPackagingItemInsights = (
  activityUuid: string,
  params?: PurchasedGoodsPackagingInsightsRetrieveParams
) =>
  usePurchasedGoodsPackagingInsightsRetrieve<PurchasedGoodItemInsights>(
    activityUuid,
    params,
    {
      request: useAxiosConfig(),
      query: {
        keepPreviousData: true,
        enabled: !!activityUuid,
      },
    }
  );
